import { useEffect, useRef } from 'react';

export default function useUpgradeDialog(isOpen, onClose) {
  const dialogRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!isOpen || !dialogRef.current) return;
    const dialog = dialogRef.current;
    const previousFocus = document.activeElement;
    const focusable = () => Array.from(dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]'));
    (focusable()[0] || dialog).focus();
    const onKeyDown = event => {
      if (!dialog.isConnected) return;
      if (event.key === 'Tab' && !dialog.contains(document.activeElement)) {
        event.preventDefault();
        (focusable()[0] || dialog).focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        closeRef.current?.();
      } else if (event.key === 'Tab') {
        const elements = focusable();
        const first = elements[0] || dialog;
        const last = elements[elements.length - 1] || dialog;
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    };
    // Listen on the document: when a focused control inside the dialog unmounts (e.g. "Try again"
    // becomes "Loading price…"), focus drops to <body> and keydowns no longer reach the dialog.
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [isOpen]);
  return dialogRef;
}
